var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.openModal === 'detailModal')?_c('row-detail-modal',{attrs:{"module-slug":_vm.detailModal.relatedModule.slug,"id":_vm.detailModal.id},on:{"cancel":function () { return _vm.openModal = null; }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }